import { IAction, IDictData } from '../../schemas';
import {
	GET_DICTSUBEXPENSE_LIST,
	ADD_DICTSUBEXPENSE,
	UPDATE_DICTSUBEXPENSE,
	DELETE_DICTSUBEXPENSE,
} from '../constant';

const initState: IDictData = {
	data: [],
	total: 0,
};

export default function dictsubexpensesReducer(
	preState = initState,
	action: IAction<any>
): IDictData {
	const { type, data } = action;
	switch (type) {
		case GET_DICTSUBEXPENSE_LIST:
			return { ...data };
		case ADD_DICTSUBEXPENSE:
			const newData = [data, ...preState.data];
			return { data: newData, total: preState.total };
		case UPDATE_DICTSUBEXPENSE:
			const index = preState.data.findIndex(
				(item) => item.id === action.data.id
			);
			const updateData = [
				...preState.data.slice(0, index),
				{
					...data,
				},
				...preState.data.slice(index + 1),
			];
			return { data: updateData, total: preState.total };
		case DELETE_DICTSUBEXPENSE:
			return {
				data: preState.data.filter((d) => d.id !== action.data.id),
				total: preState.total,
			};
		default:
			return preState;
	}
}
